import { Theme } from '../../../../store/types/theme';
import TimerFace, { PhaseSegment } from '../../../common/TimerFace';

type TimerDisplayProps = {
    progress: number;
    currentTheme: Theme;
    handleDragEvent?: (e: React.MouseEvent | React.TouchEvent) => void;
    text?: string;
    phases?: PhaseSegment[];
};

const TimerDisplay: React.FC<TimerDisplayProps> = ({ progress, currentTheme, handleDragEvent, text, phases }) => {
    return <TimerFace progress={progress} currentTheme={currentTheme} handleDragEvent={handleDragEvent} text={text} phases={phases} />;
};

TimerDisplay.displayName = 'TimerDisplay';

export default TimerDisplay;
